import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/Dashboard.css";
import "../Style/EmergencyList.css";
import { Edit2, Trash2, Siren, AlertCircle } from "lucide-react";
import axios from "axios";
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";

const EmergencyList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [emergencys, setEmergency] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const societyName = localStorage.getItem("society");
  const location = useLocation();
  const emergencyType = location.state?.emergencyTypeId;

useEffect(() => {
  if (emergencyType) {
    console.log("Selected Emergency:", emergencyType);

    const getEmergencyByAdmin = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const societyName = localStorage.getItem("society");

        const response = await axios.get(
          `${BASE_URL}/emergency/emergency-filter-by-admin`,
          {
            params: {
              societyName: societyName,
              emergencyType: emergencyType,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Filtered Emergency API Response:", response.data);
        setEmergency(response.data); 
      } catch (error) {
        console.error("Error fetching filtered emergency data:", error);
      } finally {
        setLoading(false);
      }
    };

    getEmergencyByAdmin(); 
  }
}, [emergencyType]);


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };



  const handleDelete = async (emergencyId) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${BASE_URL}/emergency/delete-emergency?emergencyId=${encodeURIComponent(emergencyId)}&societyName=${encodeURIComponent(societyName)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEmergency(emergencys.filter((item) => item.emergencyId !== emergencyId));
      toast.success("Deleted successfully ✅", {
        position: "bottom-right",
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error deleting emergency:", error);
      toast.error("Delete failed ❌", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <ToastContainer />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="emergency-list-container">
            <div className="emergency-list-card">
              <div className="emergency-list-header">
                <div className="emergency-list-title">
                  <Siren size={24} />
                  <h2>Emergency Contacts</h2>
                </div>
                <div className="emergency-count-badge">
                  {emergencys.length} {emergencys.length === 1 ? 'Contact' : 'Contacts'}
                </div>
              </div>

              <div className="emergency-list-body">
                {loading ? (
                  <div className="loading-state">
                    <AlertCircle size={48} />
                    <p>Loading emergency contacts...</p>
                  </div>
                ) : emergencys.length > 0 ? (
                  <div className="table-wrapper-emergency">
                    <table className="emergency-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Emergency Type</th>
                          <th>Address</th>
                          <th>Phone</th>
                          <th>State</th>
                          <th>City</th>
                          <th>Service Name</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {emergencys.map((emergency, index) => (
                          <tr key={emergency.id || index}>
                            <td className="index-cell">{index + 1}</td>
                            <td className="emergency-type-cell">
                              <div className="emergency-badge">
                                <AlertCircle size={16} />
                                <span>{emergency.emergency}</span>
                              </div>
                            </td>
                            <td className="address-cell">{emergency.address}</td>
                            <td className="phone-cell">
                              <a href={`tel:${emergency.phoneNumber}`} className="phone-link">
                                {emergency.phoneNumber}
                              </a>
                            </td>
                            <td>{emergency.state}</td>
                            <td>{emergency.city}</td>
                             <td>{emergency.serviceName}</td>
                            <td className="action-cell">
                              <button
                                className="action-btn edit-btn"
                                onClick={() =>
                                  navigate(`/edit-emergency/${emergency.emergencyId}`)
                                }
                                title="Edit Emergency"
                              >
                                <Edit2 size={16} />
                              </button>
                              <button
                                className="action-btn delete-btn"
                                onClick={() => handleDelete(emergency.emergencyId)}
                                title="Delete Emergency"
                              >
                                <Trash2 size={16} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="empty-state">
                    <AlertCircle size={64} />
                    <h3>No Emergency Contacts</h3>
                    <p>No emergency contacts have been added yet.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default EmergencyList;
